<section>
  <div class="footer-container vs-section-content" id="layoutFooter">
    <div class="logo-container text-center text-white ">
      <figure class="has-outline-menu">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="editar Logo" (click)="editLogo(footerData.logo)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <img class="imgLogo" [src]="footerData.logo.img"/>
      </figure>
    </div>
    <div class="footer-links">
      <div class="d-flex flex-column has-outline-menu">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="editar Sección" (click)="editSection(footerData.section1, 1)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <span class="link-header">{{footerData.section1.name}}</span>
        <p *ngFor="let footerLink of footerData.section1.detail">
          {{footerLink.name}}
        </p>
      </div>
      <div class="d-flex flex-column has-outline-menu">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="editar Sección" (click)="editSection(footerData.section2, 2)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <span class="link-header">{{footerData.section2.name}}</span>
        <p *ngFor="let footerLink of  footerData.section2.detail">
          {{footerLink.name}}
        </p>
      </div>
    </div>
    <div class="footer-contact">
      <div class="has-outline-menu">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="editar texto" (click)="editText(footerData.contact)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <div class="divider-line"></div>
        <p><strong>Contáctanos</strong><br>
          {{footerData.contact.name}}</p>
      </div>
      <div class="sectionNumber has-outline-menu">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="editar Sección de contacto" (click)="editContact(footerData.phone)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <img class="img-responsive" [src]="footerData.phone.img"/>
        <button mat-button class="button butttonfooter btnContactanos" color="primary">
          {{footerData.phone.name}}
        </button>
      </div>
      <div class="has-outline-menu">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="editar texto" (click)="editText(footerData.requeriment)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <p>{{footerData.requeriment.name}}</p>
      </div>
      <div class="has-outline-menu">
        <div class="vs-crud-menu">
          <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="editar texto" (click)="editText(footerData.consult)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
        <p>{{footerData.consult.name}}</p>
      </div>
    </div>
    <div></div>
    <div class="footer-follow">
<!--      <div class="vs-crud-menu">-->
<!--        <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="editar Social Media" (click)="editSocialMedia(footerData.rs)">-->
<!--          <mat-icon>edit</mat-icon>-->
<!--        </button>-->
<!--      </div>-->
      <div class="divider-line"></div>
      <p>Síguenos en:</p>
      <div class="follow-photos">
        <div *ngFor="let image of footerData.rs" class="has-outline-menu">
          <div class="vs-crud-menu">
            <button type="button" [disabled]="!mantenienceSection" [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="editar Social Media" (click)="editSocialMedia(image)">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
          <img [src]="image.img" [alt]="'img-' + image.item">
        </div>
      </div>
    </div>
  </div>

</section>
